import { useMemo, useState } from 'react'
import { toast } from 'react-toastify'

import { PreferredLaneRateModal } from 'legacy/containers/PreferredLanes/PreferredLaneRateModal/PreferredLaneRateModal'
import { analytics } from 'legacy/utils/analytics'

import { type PreferredLane } from '../domain/PreferredLane'
import { useSuggestedPreferredLanesContext } from './context/suggestedPreferredLanesContext'
import { usePreferredLane } from './hooks/usePreferredLane'
import { useSuggestedPreferredLanes } from './hooks/useSuggestedPreferredLanes'
import { SuggestPreferredLaneBanner } from './SuggestPreferredLaneBanner'

export function SuggestPreferredLaneLoadboard() {
  const { dismissSuggestedPreferredLane } = useSuggestedPreferredLanes()
  const { savePreferredLane, preferredLaneId } = usePreferredLane()
  const { preferredLaneSuggestions, setPreferredLaneSuggestions } =
    useSuggestedPreferredLanesContext()
  const [isRateModalOpen, setRateModalOpen] = useState(false)
  const [firstSuggestion] = preferredLaneSuggestions

  const preferredLane: PreferredLane = useMemo(() => {
    return {
      uuid: firstSuggestion?.uuid,
      origin: firstSuggestion?.origin,
      destination: firstSuggestion?.destination,
      equipmentTypes: firstSuggestion?.equipmentTypes,
      weekdays: firstSuggestion?.weekdays,
      startsAt: firstSuggestion?.startsAt,
      expiresAt: firstSuggestion?.expiresAt,
    }
  }, [firstSuggestion])

  async function dismissSuggestion() {
    const suggestions = await dismissSuggestedPreferredLane(preferredLane)
    setPreferredLaneSuggestions(suggestions)
  }

  async function handleSave() {
    try {
      await savePreferredLane(preferredLane)
      analytics.track('Preferred Lane Suggestion / Add', {
        lane: preferredLane,
        action: firstSuggestion.action,
      })
      setRateModalOpen(true)
      toast.success('Preferred lane saved successfully')
    } catch (error) {
      toast.error((error as Error).message)
    }
  }

  async function handleClosePreferredLaneRateModal() {
    setRateModalOpen(false)
    await dismissSuggestion()
  }

  return (
    <>
      {firstSuggestion && (
        <SuggestPreferredLaneBanner
          preferredLane={preferredLane}
          action={firstSuggestion.action}
          onAdd={handleSave}
          onClose={dismissSuggestion}
        />
      )}
      {isRateModalOpen && preferredLaneId && (
        <PreferredLaneRateModal
          preferredLaneId={preferredLaneId}
          lane={preferredLane}
          onClose={handleClosePreferredLaneRateModal}
          analyticsPrefix="Load Board / Preferred Lane Suggestion"
        />
      )}
    </>
  )
}
